var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PPage',{staticClass:"CoverLetterEdit"},[_c('div',{staticClass:"inner clr"},[_c('EditContainer',{attrs:{"cover-letter":_vm.$store.getters['coverLetters/coverLetter']}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }